import {Card, Col, Row, Select, Space, Spin, Typography} from 'antd';
import { TimeUnit } from 'chart.js';
import React, { useEffect, useState } from 'react';
import {useDataProvider} from 'react-admin';
import {DashboardProps, ExtendedDataProvider} from '../../types';
import ChangeInstanceLogWidget from './ChangeInstanceLogWidget';
import ChangeInstancesWidget from './ChangeInstancesWidget';
import FlowbiteUnifiedBarChart from './FlowbiteUnifiedLineChart';
import NotificationInbox from './NotificationInbox';
import ServiceItemsWidget from './ServiceItemsWidget';
import useGetGraphStatistics from './useGetGraphStatistics';
import GeneralFilter from "../ChangeInstances/GeneralFilter";
const { Option } = Select;
const { Title, Text } = Typography;

const SpinningCard = (
    <Card bordered={false} className="criclebox">
        <Spin style={{ display: 'flex', justifyContent: 'center', padding: '24px 0' }} />
    </Card>
)

const BaseDashboard = ({ pov, applicationsResource, teamsResource, servicesResource, statisticsResource }: DashboardProps) => {
    const dataProvider: ExtendedDataProvider = useDataProvider()
    const [dashboardWidgets, setDashboardWidgets] = useState<JSX.Element[]>([SpinningCard, SpinningCard])
    const [filterValues, setFilterValues] = useState<any>({})
    const { setGraphIntervalUnit, processedChangesGraphData, avgTimeCompletionGraphData, graphIntervalUnit, isLoaded: chartLoaded } = useGetGraphStatistics(filterValues, setFilterValues, pov)

    useEffect(() => {
        setDashboardWidgets([SpinningCard, SpinningCard])
        dataProvider.getAction(statisticsResource, {
            verb: 'basics',
            filter: filterValues
        })
            .then((response: any) => {
                setDashboardWidgets([
                    <ChangeInstancesWidget data={response.data} />,
                    <ServiceItemsWidget data={response.data} />
                ])
            })
            .catch((error) => { console.error(error) })

    }, [filterValues, pov])

    useEffect(() => {
        setFilterValues({})
    }, [pov])

    return (
        <Space orientation="vertical">
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <GeneralFilter
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    applicationsResource={pov==="CONSUMER"?applicationsResource:undefined}
                    teamsResource={pov==="CONSUMER"?undefined:teamsResource}
                    servicesResource={servicesResource}
                    style={{ flex: 1, padding: '0px', marginBottom: '0px' }}
                    stateFilterEnabled={false}
                    changeTypeFilterEnabled={false}
                />
                <div style={{ paddingRight: '16px' }} >
                    <NotificationInbox />
                </div>
            </div>
            <Row gutter={[8, 0]} className="dashboard-viewport">
                <Col xs={24} lg={17} className="dashboard-main-col">
                    <Row gutter={[8, 8]}>
                        {dashboardWidgets.map((widget, index) => (
                            <Col key={index} xs={24} sm={12}>{widget}</Col>
                        ))}
                    </Row>

                    <div className="dashboard-chart-fill">
                        <Card className="dashboard-chart-card" style={{ height: '100%' }}>
                            <div className="dashboard-chart-header">
                                <div>
                                    <Title level={5}>Change Instances Metrics</Title>
                                    <Text type="secondary">
                                        Average completion time and number of completed changes over time
                                    </Text>
                                </div>
                                <Select defaultValue='month' style={{ width: '120px' }} className="filter-select" onChange={(value: TimeUnit) => setGraphIntervalUnit(value)}>
                                    <Option key={0} value="month">Monthly</Option>
                                    <Option key={1} value="week">Weekly</Option>
                                    <Option key={2} value="day">Daily</Option>
                                </Select>
                            </div>
                            <FlowbiteUnifiedBarChart
                                avgTimeData={avgTimeCompletionGraphData}
                                changesData={processedChangesGraphData}
                                unit={graphIntervalUnit}
                                loading={!chartLoaded}
                            />
                        </Card>
                    </div>
                </Col>

                <Col xs={24} lg={7} className="dashboard-history-col">
                    <ChangeInstanceLogWidget pov={pov} filterValues={filterValues}/>
                </Col>
            </Row>
        </Space>
    )
}

export default BaseDashboard;
